import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-auth',
  imports: [RouterModule],
  templateUrl: './auth.html',
  styleUrl: './auth.scss',
  standalone: true,
})
export class Auth {

}
